import { render, staticRenderFns } from "./laborSource.vue?vue&type=template&id=54d956e3&scoped=true&"
import script from "./laborSource.vue?vue&type=script&lang=js&"
export * from "./laborSource.vue?vue&type=script&lang=js&"
import style0 from "./laborSource.vue?vue&type=style&index=0&id=54d956e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d956e3",
  null
  
)

export default component.exports